import { createCRUDHook } from './createCRUDHook';
import { ManufacturerDto } from 'utils/models';
import { CRM_MANUFACTURE } from './apiEndPoints';

const { Context, useManager, useConsumer } = createCRUDHook<ManufacturerDto>({
  entityName: 'Manufacturer',
  endpoint: CRM_MANUFACTURE,
});

export const ManufacturerContext = Context;
export const useManufacturerManager = useManager;
export const useManufacturer = useConsumer;
